<template>
  <div v-loading="loading" class="app-wrapper">
    <div v-if="isauthenticated" class="main-container">
      <navbar />
      <section class="app-main">
        <transition name="fade-transform" mode="out-in">
          <div class="brains-main-container">
            <div class="brains-filters-container"><filterBar ref="exploreFilter" /></div>
            <div v-if="actualview !== 'reports'" class="brains-columns-container">
              <div class="brains-left-column-container">
                <brainsmap v-show="selectedmap.mapvisualizationval !== 'wms_view'" />
                <wmsmap v-show="selectedmap.mapvisualizationval === 'wms_view'" />
              </div>
              <div :class="{ 'brains-right-sidebar-container--close': !sideOpened }" class="brains-right-sidebar-container">
                <div class="column-close-open-btn" @click="sideOpened = !sideOpened">
                  <em v-if="sideOpened" class="el-icon-arrow-right" />
                  <em v-else class="el-icon-arrow-left" />
                </div>

                <div :class="{ 'hiderightview': !sideOpened }" class="brains-right-sidebar-container--content">
                  <!--<router-view :key="key" />-->
                  <div class="brains-right-column-content-container">
                    <tabs ref="valuationsTabs" :useorder="true" @selectedTab="tabChanged">
                      <!--explore-->
                      <tab v-if="actualview === 'explore'" name="Ranking" :ordernumber="1" :selected="calculateselected('Ranking')" :padding="false">
                        <rankingChart />
                      </tab>
                      <!--valuation-->
                      <tab v-if="actualview === 'valuation'" name="Value" :ordernumber="2" :selected="calculateselected('Value')" :padding="false">
                        <valuation />
                      </tab>
                      <tab v-if="actualview === 'valuation'" name="Comps" :ordernumber="3" :padding="false">
                        <!--<keep-alive>
                          <complist />
                        </keep-alive>-->
                        <complist />
                      </tab>
                      <tab v-if="actualview === 'valuation'" name="Stock" :ordernumber="4" :padding="false">
                        <valuationStock />
                      </tab>
                      <!--portfolio-->
                      <tab v-if="actualview === 'portfolio'" name="List" :ordernumber="5" :selected="calculateselected('List')" :padding="false">
                        <portfolioList />
                      </tab>
                      <tab v-if="actualview === 'portfolio'" name="Strats" :ordernumber="6" :padding="false">
                        <portfolioStrats />
                      </tab>
                      <tab v-if="actualview === 'portfolio'" name="Compare" :ordernumber="7" :padding="false">
                        <portfolioCompare />
                      </tab>
                      <!--all-->
                      <tab name="Charts" :ordernumber="8" :padding="false">
                        <brainsChart />
                      </tab>
                      <tab name="Data" :ordernumber="9" :padding="false">
                        <dataSidebar />
                      </tab>
                      <tab name="Images" :ordernumber="10" :padding="false">
                        <streetview ref="sview" />
                      </tab>
                      <tab name="Poi" :ordernumber="10" :padding="false">
                        <pois />
                      </tab>
                    </tabs>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="brains-columns-container">
              <reports />
            </div>
          </div>
        </transition>
      </section>
    </div>
    <login v-else />
  </div>
</template>

<script>
import Login from '@/components/Login.vue'
import navbar from '@/components/Navbar.vue'
import brainsmap from '@/components/BrainsMap.vue'
import wmsmap from '@/components/BrainsWmsMap.vue'
import filterBar from '@/components/FilterBar.vue'
import tabs from '@/components/designComponents/tabs'
import tab from '@/components/designComponents/tab'
import pois from '@/components/Pois'
import streetview from '@/components/StreetViewImages'
import dataSidebar from '@/components/dataSidebar'
import rankingChart from '@/components/rankingChart'
import brainsChart from '@/components/BrainsChart'
import portfolioStrats from '@/components/portfolioStrats'
import portfolioCompare from '@/components/portfolioCompare'
import portfolioList from '@/components/portfolioList'
import complist from '@/components/CompsList'
import valuationStock from '@/components/valuationStock.vue'
import valuation from '@/components/valuation.vue'
import reports from '@/components/reports.vue'
import { mapState } from 'vuex'
export default {
  name: 'Layout',
  components: { Login, navbar, filterBar, brainsmap, wmsmap, tabs, tab, pois, streetview, dataSidebar, rankingChart, brainsChart, complist, valuationStock, valuation, portfolioStrats, portfolioList, reports, portfolioCompare },
  data() {
    return {
      loading: false,
      sideOpened: true,
      acttab: 'Ranking'
    }
  },
  computed: {
    ...mapState('user', {
      isauthenticated: (state) => state.isauthenticated,
      activeNav: (state) => state.activeNav
    }),
    ...mapState('maps', {
      selectedmap: (state) => state.selectedmap
    }),
    actualview() {
      if (this.activeNav === 'valuation') {
        return 'valuation'
      } else if (this.activeNav === 'portfolio') {
        return 'portfolio'
      } else if (this.activeNav === 'reports') {
        return 'reports'
      }
      return 'explore'
    }
  },
  created() {
    const vm = this
    vm.loading = true

    if (localStorage.getItem('lang') === null) {
      localStorage.setItem('lang', 'it')
    }

    if (document.location.href.lastIndexOf('/logout') > 0) {
      vm.loading = false
      return
    }
    vm.$store.dispatch('user/gettoken').then(() => {
      vm.loading = false
      if (vm.$route.query.latitude && vm.$route.query.longitude) {
        var place = {
          geometry: {
            location: {
              lat: function() {
                return parseFloat(vm.$route.query.latitude)
              },
              lng: function() {
                return parseFloat(vm.$route.query.longitude)
              }
            }
          }
        }
        vm.$store.dispatch('location/searchlocations', place)
      }
    }).catch(() => {
      if (vm.isauthenticated) {
        document.location.reload()
      } else {
        vm.$store.dispatch('user/login').then(() => {
          document.location.reload()
        })
      }
      // debugger
      vm.loading = false
    })
  },
  methods: {
    tabChanged(data) {
      this.acttab = data
      if (data === 'Images') {
        this.svVisible = true
        this.$refs.sview.initView()
      } else if (data === 'Charts') {
        this.svVisible = true
      }
    },
    calculateselected(view) {
      const vm = this
      const tab = vm.$refs.valuationsTabs
      if (view === vm.acttab) {
        return true
      }
      if (vm.actualview === 'explore') {
        if (vm.acttab === 'Ranking' || (vm.acttab === 'Value' || vm.acttab === 'Comps' || vm.acttab === 'Stock' || vm.acttab === 'List' || vm.acttab === 'Strats')) {
          vm.acttab = view
          return true
        }
      } else if (vm.actualview === 'valuation') {
        if (vm.acttab === '' || (vm.acttab === 'Ranking' || vm.acttab === 'List' || vm.acttab === 'Strats')) {
          tab.unselectall()
          vm.acttab = view
          return true
        }
      } else if (vm.actualview === 'portfolio') {
        if (vm.acttab === '' || (vm.acttab === 'Ranking' || vm.acttab === 'Value' || vm.acttab === 'Comps' || vm.acttab === 'Stock')) {
          tab.unselectall()
          vm.acttab = view
          return true
        }
      }
      return false
    }
  }
}
</script>
<style lang="scss" scoped>
.hiderightview{
  display: none;
}
.brains-columns-container {
  height: calc(100vh - 110px);
  min-height: calc(100vh - 110px);
  display: flex;
}

.brains-left-column-container {
  width: 100vw;
  height: 100%;
}

.brains-filters-container {
  border-bottom: 1px solid #c0c4cc;
}

.brains-right-sidebar-container {
  width: 80vw;
  height: 100%;
  background-color: white;
  position: relative;
  transition: all 0.5s;
  max-width: 800px;
  min-width: 800px;

  &--content {

    // overflow-y: hidden;
    // overflow-x: scroll;
  }

  &--close {
    width: 0;
    min-width: 0;
  }
}

.column-close-open-btn {
  width: 50px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  border: 1px solid #c0c4cc;
  border-right: none;
  position: absolute;
  left: -50px;
  top: 38px;
  border-radius: 15px 0 0 15px;
  cursor: pointer;
  z-index: 2;

  i {
    font-size: 32px;
    font-weight: 900;
  }
}
</style>

